import type { Maybe, MenuGroup, MenuGroupItem, SettingMenuValue } from '@/types'

import { cutExcess } from '@/helpers'
/**
 * Menu / Footer
 * */
export function prepareGroups<T = SettingMenuValue>(
  value: T & { groups: any[] }
) {
  const groups = value.groups.map((group) => {
    const items = group.items.map(prepareMenuGroupItem)

    return { ...group, items }
  })

  return { ...value, groups }
}

export function prepareMenuGroupItem<T = MenuGroupItem>(
  item: T & { name: any },
  index: number
): T {
  return {
    ...item,
    id: btoa(encodeURIComponent(item.name ?? String(index))),
  }
}

export function prepareGroupsBackwards<T = MenuGroup<MenuGroupItem>>(
  groups: (T & { items: any[] })[]
) {
  return groups.map((group) => {
    const items = group.items.map((item) => {
      delete item.id

      return item
    })

    return { ...group, items }
  })
}

const host = (import.meta.env.VITE_HOST ?? '') as string

export function checkIfExternal(url?: Maybe<string>) {
  if (!url) return false
  if (url.startsWith('/')) return false

  let origin = null

  try {
    origin = new URL(url).origin
  } catch (e) {
    //
  }

  return origin ? !new RegExp(host).test(origin) : true
}

export function prepareMenuUrl(url?: Maybe<string>) {
  if (!url) return '#'
  if (url.startsWith('/')) return url

  return `/${cutExcess(url, host)}`
}

export function prepareExternalUrl(url?: Maybe<string>) {
  if (!url) return '#'

  const strings = ['https://', 'www.', '/']
  if (strings.some((item) => url.startsWith(item))) return url

  return `//${url}`
}

export function prepareAnyUrl(link?: Maybe<string>) {
  return checkIfExternal(link) ? prepareExternalUrl(link) : prepareMenuUrl(link)
}
